// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".selWidth[data-v-71032707] {\n  width: 220px;\n}\n.selWidthSm[data-v-71032707] {\n  width: 140px;\n}\n.tips[data-v-71032707] {\n  color: #999;\n  font-size: 13px;\n  line-height: 20px;\n  margin-bottom: 12px;\n}\n.hint[data-v-71032707] {\n  color: #999;\n  font-size: 12px;\n  line-height: 18px;\n}\n.block[data-v-71032707] {\n  margin-top: 12px;\n  text-align: right;\n}", ""]);
// Exports
module.exports = exports;
